import { CodeLogin } from '@gripp/shared-ui';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthSplitLayout } from './authSplitLayout';

export const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handleRedirect = async (redirectPath: string) => {
    navigate(redirectPath);
    return Promise.resolve();
  };

  return (
    <AuthSplitLayout>
      <CodeLogin
        handleRedirect={handleRedirect}
        onCodeSent={() => navigate('/verify-auth-code')}
        onRegister={() => navigate('/register')}
        initialEmail={searchParams.get('email') ?? undefined}
      />
    </AuthSplitLayout>
  );
};
